import { render, staticRenderFns } from "./ClientIdentification.vue?vue&type=template&id=492ab451"
import script from "./ClientIdentification.vue?vue&type=script&lang=js"
export * from "./ClientIdentification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports